export default "/images/it.png?6c299fcc552b8f16422e1955d4c94411";